import { HowAcademyWorksPayload } from '~/common/types/types';

const howAcademyWorksPayload: HowAcademyWorksPayload = {
  title: 'info.title',
  description: 'info.description',
  items: [
    {
      title: 'info.group0.title',
      description: 'info.group0.description',
    },
    {
      title: 'info.group1.title',
      description: 'info.group1.description',
    },
    {
      title: 'info.group2.title',
      description: 'info.group2.description',
    },
    {
      title: 'info.group3.title',
      description: 'info.group3.description',
    },
    {
      title: 'info.group4.title',
      description: 'info.group4.description',
    },
  ],
};

export { howAcademyWorksPayload };
